export const WM_INSURANCE_DUMMY_ADVANTAGES = [
  'Online and in-app messaging with your dedicated care team',
  'Appointment booking online',
  'Simple prescription renewals',
  'LifeMD program discounts',
  'Access to health metrics to track your progress'
];

export const INSURANCE_FAQ = [
  {
    id: '1',
    text: `Our $19/month access fee is a highly discounted rate compared to the standard price of our weight management program. With this membership, you gain access to expert provider care, ongoing support, and prescription GLP-1 medications. Additionally, our team works directly with your insurance to secure coverage for GLP-1s, meaning you'll actually be saving hundreds of dollars each month by signing up today with insurance. Staying enrolled ensures you continue receiving comprehensive care and maximizing your savings.`,
    title: 'Why am I being charged for the membership?'
  },
  {
    id: '2',
    text: `Your insurance covers provider visits, consultations, and prescription services. The LifeMD Weight Management Program is an additional membership that enhances your care with tools, support, and exclusive savings.`,
    title: 'What does my insurance cover?'
  },
  {
    id: '3',
    text: `We work with your insurance to help secure coverage for GLP-1 medications like Wegovy and Zepbound. Coverage varies, and our team will guide you through your options and next steps.`,
    title: 'Will my insurance cover GLP-1 medications?'
  },
  {
    id: '4',
    text: 'Alongside your covered provider visits, the LifeMD program gives you 24/7 access to messaging, prescription renewals, and expert support to help you stay on track with your weight loss goals.',
    title: 'How does the program work?'
  },
  {
    id: '5',
    text: 'Medication costs are separate, but we assist in working with your insurance to determine coverage options and ensure you get the best pricing available.',
    title: 'Is medication included in the plan?'
  }
];

export const hardcodedInsuranceProviders = [
  {
    _id: 'other-aetna',
    label: 'Aetna',
    value: 'aetna'
  },
  {
    _id: 'other-anthem',
    label: 'Anthem',
    value: 'anthem'
  },
  {
    _id: 'other-blue_cross_blue_shield',
    label: 'BlueCross BlueShield',
    value: 'blue_cross_blue_shield'
  },
  {
    _id: 'other-centene',
    label: 'Centene',
    value: 'centene'
  },
  {
    _id: 'other-cigna',
    label: 'Cigna',
    value: 'cigna'
  },
  {
    _id: 'other-florida_blue',
    label: 'Florida Blue',
    value: 'florida_blue'
  },
  {
    _id: 'other-humana',
    label: 'Humana',
    value: 'humana'
  },
  {
    _id: 'other-kaiser_permanente',
    label: 'Kaiser Permanente',
    value: 'kaiser_permanente'
  },
  {
    _id: 'other-united_healthcare',
    label: 'United Healthcare',
    value: 'united_healthcare'
  },
  {
    _id: 'other-wellcare',
    label: 'Wellcare',
    value: 'wellcare'
  }
];

export const hardcodedInsuranceProvidersExtended = [
  ...hardcodedInsuranceProviders,
  { _id: 'other-carefirst', label: 'CareFirst', value: 'carefirst' },
  { _id: 'other-emblemhealth', label: 'EmblemHealth', value: 'emblemhealth' },
  { _id: 'other-guidewell', label: 'GuideWell (Florida Blue)', value: 'guidewell' },
  { _id: 'other-hcsc', label: 'Health Care Service Corporation (HCSC)', value: 'hcsc' },
  { _id: 'other-health_net', label: 'Health Net', value: 'health_net' },
  { _id: 'other-highmark_health', label: 'Highmark Health', value: 'highmark_health' },
  {
    _id: 'other-independence_blue_cross',
    label: 'Independence Blue Cross',
    value: 'independence_blue_cross'
  },
  {
    _id: 'other-independence_health_group',
    label: 'Independence Health Group',
    value: 'independence_health_group'
  },
  {
    _id: 'medicare_part_c',
    label: 'Medicare Part C (Medicare Advantage)',
    value: 'medicare_part_c'
  },
  { _id: 'other-medicaid', label: 'Medicaid', value: 'medicaid' },
  { _id: 'other-molina_healthcare', label: 'Molina Healthcare', value: 'molina_healthcare' },
  { _id: 'other-wellmark', label: 'Wellmark Blue Cross Blue Shield', value: 'wellmark' }
];
